module.exports = __webpack_public_path__ + "static/media/explore-1.6ed8579b.jpg";